import { connectRouter, routerMiddleware, RouterState } from "connected-react-router";
import { createBrowserHistory, History } from "history";
import { Action, applyMiddleware, combineReducers, compose, createStore, DeepPartial } from "redux";
import sagaMiddleware from "redux-saga";
import { appReducer, INITIAL_STATE, IState } from "./App/reducer";

export interface IStore {
  App: IState["App"];
  router: RouterState;
}

export const history: History = createBrowserHistory({
  basename: "/v2",
});
export const sagas = sagaMiddleware();
const router = routerMiddleware(history);

const composeEnhancers =
  (process.env.NODE_ENV === "development" && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const initStore = (preloadedState: DeepPartial<IStore>) =>
  createStore(
    combineReducers<IStore, Action>({
      App: appReducer,
      router: connectRouter(history),
    }),
    preloadedState,
    composeEnhancers(applyMiddleware(router, sagas))
  );

export const store = initStore({
  App: {
    _: INITIAL_STATE,
  },
});
